export const instumentalAndFunctionalMethodsOfDiagnosticsConst = {
  path: "/single-programs/instumental-and-functional-methods-of-diagnostics",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ИНСТРУМЕНТАЛЬНЫЕ И ФУНКЦИОНАЛЬНЫЕ МЕТОДЫ ДИАГНОСТИКИ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Точность и технологии на службе медицины</h2>
      <p>
        Программа по инструментальным и функциональным методам диагностики подготавливает специалистов, владеющих современными технологиями
        визуализации и функционального обследования организма. Это ключевая область современной медицины, обеспечивающая своевременное и
        точное выявление заболеваний.
      </p>
      <p>Студенты получают знания и практические навыки работы с:</p>
      <ul>
        <li>Ультразвуковыми исследованиями (УЗИ)</li>
        <li>Электрокардиографией (ЭКГ)</li>
        <li>Магнитно-резонансной томографией (МРТ)</li>
      </ul>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и патофизиология органов и систем</li>
        <li>Принципы работы диагностической техники</li>
        <li>Интерпретация результатов исследований</li>
        <li>Радиационная безопасность и стандарты качества</li>
        <li>Ведение медицинской документации</li>
        <li>Практика в клиниках и диагностических центрах</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач ультразвуковой диагностики</li>
        <li>Рентгенолог</li>
        <li>Врач МРТ / КТ</li>
        <li>Врач функциональной диагностики</li>
        <li>Специалист по эндоскопическим исследованиям</li>
        <li>Консультант по диагностическим технологиям</li>
      </ul>
      <h2>Востребованность и зарплата</h2>
      <p>
        Диагностика — это фундамент любого лечения. Квалифицированные специалисты востребованы в клиниках, диагностических центрах, научных
        учреждениях.
      </p>
      <p>
        <strong>Средняя зарплата в Европе: от €55,000 до €100,000 в год,</strong> в зависимости от специализации и опыта.
      </p>
      <h2>Почему выбирают нашу программу?</h2>
      <ul>
        <li>Обучение на современных диагностических платформах</li>
        <li>Практика в ведущих медицинских учреждениях</li>
        <li>Доступ к симуляционному оборудованию</li>
        <li>Международный диплом, признанный в ЕС</li>
        <li>Возможность специализации и карьерного роста</li>
      </ul>
      <h2>Инструментальная диагностика — это глаза современной медицины</h2>
      <p>
        Специалисты этой области делают невидимое — видимым, помогая врачам всех направлений ставить точные диагнозы и выбирать эффективную
        тактику лечения.
      </p>
      <br />
      <p className="padding-left">«Правильная диагностика — это уже половина успешного лечения.»</p>
      <h2>Как поступить?</h2>
      <p>Узнайте подробности о стоимости и условиях — оставьте заявку на консультацию! </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Точность и технологии на службе медицины
    Программа по инструментальным и функциональным методам диагностики подготавливает специалистов, владеющих современными технологиями визуализации и функционального обследования организма. Это ключевая область современной медицины, обеспечивающая своевременное и точное выявление заболеваний.
    Студенты получают знания и практические навыки работы с:
    Ультразвуковыми исследованиями (УЗИ)
    Электрокардиографией (ЭКГ)
    Магнитно-резонансной томографией (МРТ)

    Что вы будете изучать?
    • Анатомия и патофизиология органов и систем
    • Принципы работы диагностической техники
    • Интерпретация результатов исследований
    • Радиационная безопасность и стандарты качества
    • Ведение медицинской документации
    • Практика в клиниках и диагностических центрах

    Кем можно работать после окончания?
    • Врач ультразвуковой диагностики
    • Рентгенолог
    • Врач МРТ / КТ
    • Врач функциональной диагностики
    • Специалист по эндоскопическим исследованиям
    • Консультант по диагностическим технологиям

    Востребованность и зарплата
    Диагностика — это фундамент любого лечения. Квалифицированные специалисты востребованы в клиниках, диагностических центрах, научных учреждениях.
    Средняя зарплата в Европе: от €55,000 до €100,000 в год, в зависимости от специализации и опыта.

    Почему стоит выбрать эту программу?
    • Обучение на современных диагностических платформах
    • Практика в ведущих медицинских учреждениях
    • Доступ к симуляционному оборудованию
    • Международный диплом, признанный в ЕС
    • Возможность специализации и карьерного роста

    Инструментальная диагностика — это глаза современной медицины
    Специалисты этой области делают невидимое — видимым, помогая врачам всех направлений ставить точные диагнозы и выбирать эффективную тактику лечения.
    «Правильная диагностика — это уже половина успешного лечения.»

    Как поступить?
    Узнайте подробности о стоимости и условиях — оставьте заявку на консультацию! 
  `,
};
